<template>
  <div class="event-fnd_employees">
    <modal title="Призяка пользователя" :subtitle="''"
      @close="switchModal()"
      v-if="modal">
      <fnd-employee @close="switchModal" :data="fndID"/>
    </modal>
    <div class="fnd_employees-actions">
      <ccs-input class="action-search" type="autocomplete" label=""
        v-model="employeesFndIDFilter" placeholder="Поиск по ФНД" :items="fndsForSelect"
        @change="onFndSearch" @select="getEmployees"/>
      <button class="ccs-button ccs-button--white ccs-button--small" @click="switchModal()">
        <img src="@/assets/icons/add.svg" alt="" class="button-icon">
        Привязать пользователя
      </button>
    </div>
    <ccs-table :data="eventEmployees" :columnsDefs="columnsDefs">
      <template v-slot:fnd_role="props">
        {{ fndRoles[props.row.fnd_role] }}
      </template>
      <template v-slot:name="props">
        <v-icon v-if="permissionsStatus.isFndUpdateAllowed"
          class="ccs-icon--secondary ccs-icon--hover" name="trash" scale="0.9"
          @click="removeEmployee(props.row)"/>
      </template>
    </ccs-table>
    <pagination :dataFunction="getEmployees"/>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';

import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Modal from '@/components/Modal.vue';
import Table from '@/components/Table.vue';
import Input from '@/components/forms/Input.vue';
import Pagination from '@/components/Pagination.vue';
import FndEmployee from '@/components/modals/fnds/FndEmployee.vue';

export default {
  name: 'KnowledgeBase',
  mixins: [AutocompleteParent],
  components: {
    'ccs-input': Input,
    'ccs-table': Table,
    Modal,
    Pagination,
    FndEmployee,
  },
  data() {
    return {
      modal: false,
      fndID: undefined,
      fndsForSelect: [],
      columnsDefs: [{
        name: `email`,
        title: 'Email',
        prop: 'email',
      }, {
        name: `full_name`,
        title: 'ФИО',
        prop: 'full_name',
      }, {
        name: `fnd_role`,
        title: 'Роль',
        prop: 'fnd_role',
      }, {
        name: `fnd_organization_name`,
        title: 'Организация',
        prop: 'fnd_organization_name',
      }, {
        name: `fnd_code`,
        title: 'ФНД',
        prop: 'fnd_code',
      }, {
        name: `name`,
        title: ``,
        prop: `name`,
        isActions: true
      }],
      fndRoles: {
        'leader': 'Лидер ФНД',
        'block_leader': 'Лидер блока',
        'employee': 'Сотрудник ФНД',
      }
    };
  },
  computed: {
    ...mapGetters('session', ['permissionsStatus']),
    ...mapState('events', ['event', 'eventEmployees', 'eventEmployeesFilters']),
    title() {
      return this.editableFile ? this.titles.edit : this.titles.new;
    },
    filteredEmployees() {
      return this.eventEmployees.filter(item => item.name.indexOf(this.employeeSearch) !== -1);
    },
    employeesFndIDFilter: {
      get() {
        return this.eventEmployeesFilters.fndID;
      },
      set(val) {
        this.setEmployeesFndIDFilter(val);
      }
    }
  },
  methods: {
    ...mapActions('fnd', ['attachUserToFnd', 'detachUserFromFnd']),
    ...mapActions('events', ['getEmployees']),
    ...mapMutations('events', ['setEmployeesFndIDFilter']),
    switchModal() {
      this.modal = !this.modal;
    },
    openFileLink(url) {
      window.open(url, '_blank');
    },
    async onFndSearch(text) {
      [this.fndsForSelect] = await this.getAutocompleteData('/v1/fnd/list', text, 'id', 'code', (item) => item.code);
    },
    removeEmployee(employee) {
      this.$toasted.info("Открепить пользователя?", { action: [{
        text: "Да",
        onClick: (e, toastObject) => {
          this.removeEmployeeRequest(employee);
          toastObject.goAway(0);
        },
      }, {
        text: "Нет",
        onClick: (e, toastObject) => {
          toastObject.goAway(0);
        },
      }]});
    },
    async removeEmployeeRequest(employee) {
      try {
        await this.detachUserFromFnd({
          user_id: employee.id,
          fnd_id: employee.fnd_id,
          fnd_organization_id: employee.fnd_organization_id,
          event_id: this.event.id,
          role: employee.fnd_role,
        });
        this.$toasted.success('Пользователь откреплен');
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.event-fnd_employees {
  min-height: 100%;
  min-width: 100%;

  .fnd_employees-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .ccs-table {
    margin-top: 20px;
  }

  .button--add {
    margin-top: 22px;
  }

  .modal-table {
    margin-top: 30px;
  }

}
</style>
